import React, {Component} from 'react';
import queryString from "query-string";
import {withRouter} from 'react-router-dom';
import {RadioButton} from '../../../../../components/radioButton';
import {CheckBox} from '../../../../../components/checkbox';
import {ConstructionTypeTitleSorted, ConstructionTypeTitle} from "../../../../../constants/constructionTypes";
import {Filters, Header, Row} from './style';

class ConstructionFilters extends Component {
	constructor(props) {
		super(props);

		const {history} = props;
		const params = queryString.parse(history.location.search);		

		this.state = {
			filters: (params.filters && params.filters.length > 0 ? 
											params.filters.split(',') : Object.keys(ConstructionTypeTitle)).map(n => parseInt(n)),
			level: params.level,
			pushed: true
		}

		this.changeFilter = this.changeFilter.bind(this);
		this.changeLevel = this.changeLevel.bind(this);
		this.pushHistory = this.pushHistory.bind(this);
	}

	static getDerivedStateFromProps(props, state) {
		const {history} = props;
		const params = queryString.parse(history.location.search);

		if(state.pushed) {
			return {
				...state,
				filters: (params.filters && params.filters.length > 0 ? 
												params.filters.split(',') : Object.keys(ConstructionTypeTitle)).map(n => parseInt(n)),
				level: params.level
			}
		}

		return state;
	}

	changeFilter(filter) {		
		const {filters} = this.state;
		let newFilters = filters && filters.filter(f => f !== filter);						
		newFilters = filters && filters.length === newFilters.length ? [...newFilters, filter] : newFilters; 		
		this.setState({filters: newFilters, pushed: false}, this.pushHistory);
	} 

	changeLevel(level) {
		this.setState({'level': level, pushed: false}, this.pushHistory);		
	}
	
	pushHistory() {		
		const {history} = this.props;
		const {level, filters} = this.state;

		history.push('/construction-component?'+queryString.stringify({
				...queryString.parse(history.location.search), 
				filters: filters.join(','), 
				level
		}));
		this.setState({pushed: true});
	}	

	render() {
		const {level, filters} = this.state;

		return (
			<React.Fragment>
			{			
				parseInt(localStorage.getItem("construction_component_level")) === 2 &&	
				<Filters>
					<Header>نمایش بر اساس</Header>	
					<Row>
						<RadioButton label="سطح یک" select={!level || parseInt(level) === 1} onSelect={() => this.changeLevel(1)} />
					</Row>
					<Row>
						<RadioButton label="سطح دو" select={parseInt(level) === 2} onSelect={() => this.changeLevel(2)} />
					</Row>
				</Filters>
			}
			<Filters>
				<Header>نوع منبع</Header>
				{
					ConstructionTypeTitleSorted.map(item => {
						// console.log(Object.keys(ConstructionTypeTitle), Object.entries(ConstructionTypeTitle));
						return(
						<Row key={item.type}>
							<CheckBox 							
								label={item.value}
								checked={filters.indexOf(parseInt(item.type)) !== -1}
								onSelect={() => this.changeFilter(parseInt(item.type))}
							/>
						</Row>
					)})
				}				
			</Filters>
		</React.Fragment>
		)
	}
}

export const FilterComponent = withRouter(ConstructionFilters);